import moment from "moment";

// Shared by the dashboard "Client Review Due" card and the Client reviews page.

export const memberName = (row) =>
  `${row?.first_name || ""} ${row?.last_name || ""}`.trim() || "Member";

const plural = (n, word) => `${n} ${word}${n === 1 ? "" : "s"}`;

/**
 * Status of a review row; due_status and days (minus = overdue) come from the API.
 * color is a Label colour: overdue red, today orange, next 7 days blue, later grey.
 */
export const dueStatus = (row) => {
  const days = Math.abs(row?.days || 0);
  switch (row?.due_status) {
    case "overdue":
      return { color: "error", label: `Overdue · ${plural(days, "day")}` };
    case "today":
      return { color: "warning", label: "Today" };
    case "upcoming":
      return { color: "info", label: `In ${plural(days, "day")}` };
    default:
      return { color: "default", label: `In ${plural(days, "day")}` };
  }
};

export const formatDueDate = (date) => moment(date).format("DD-MM-YYYY");

// Client reviews page, All tab "Due date" filter: whole calendar periods (weeks Monday – Sunday),
// both days included.
export const DAY_FORMAT = "YYYY-MM-DD";

export const DUE_DATE_OPTIONS = [
  { value: "any", label: "All dates" },
  { value: "this_week", label: "This week" },
  { value: "next_week", label: "Next week" },
  { value: "this_month", label: "This month" },
  { value: "next_month", label: "Next month" },
  { value: "custom", label: "Custom range" },
];

const period = (start, unit) => ({
  from: start.clone().startOf(unit).format(DAY_FORMAT),
  to: start.clone().endOf(unit).format(DAY_FORMAT),
});

export const presetRange = (value) => {
  const today = moment().startOf("day");
  switch (value) {
    case "this_week":
      return period(today, "isoWeek");
    case "next_week":
      return period(today.clone().add(1, "week"), "isoWeek");
    case "this_month":
      return period(today, "month");
    case "next_month":
      return period(today.clone().add(1, "month"), "month");
    default:
      return { from: "", to: "" };
  }
};

const showDay = (value) => moment(value, DAY_FORMAT).format("DD-MM-YYYY");

export const rangeText = ({ from, to }) => {
  if (from && to) return `${showDay(from)} – ${showDay(to)}`;
  return from ? `from ${showDay(from)}` : `until ${showDay(to)}`;
};
